import { Component, DoCheck, ElementRef, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";
import { ActivatedRoute, Router } from "@angular/router";
import { ResultStatus } from "@app/core/models/result-status";
import { CommunityService } from "@app/core/services/community.service";
import { ToastrService } from "ngx-toastr";
import * as _ from "lodash";
import { HelperService } from "@app/core/services/helper.service";
import { Subscription } from "rxjs";
import { AppConfig } from '@app/core/Utilities/app-config.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';

@Component({
  selector: "app-community-layout",
  templateUrl: "./community-layout.component.html",
  styleUrls: ["./community-layout.component.scss"],
})
export class CommunityLayoutComponent implements OnInit, OnDestroy, DoCheck {
  private routeSubscription: Subscription;
  @ViewChild("comunityRuleTemplate") comunityRuleTemplate: ElementRef;
  groupList = [];
  feedList = [];
  selectedGroupId = 0;
  selectedfeedId = 0;
  selectedTag = "";
  trendingTagList = [];
  trendingPostList = [];
  hasSavedPost = false;
  hasReportedPost = false;
  public showCounterLimit = 0;
  public showCounter = 0;
  public isShowLess = false;
  openCommunityMenu = false;
  isFeed = false;
  isAdminUser = false;
  filterValue = [];

  public bsModalRef: BsModalRef;

  constructor(
    private communityService: CommunityService,
    private sanitizer: DomSanitizer,
    private toaterService: ToastrService,
    private router: Router,
    public route: ActivatedRoute,
    private appConfig: AppConfig,
    private helperService: HelperService,
    private modalService: BsModalService,
  ) {
    this.showCounterLimit = 2;
    this.showCounter = this.showCounterLimit;
  }

  ngOnInit() {
    if (this.appConfig.SharedComponent.loggedInUserInfo !== null) {
      this.isAdminUser = this.appConfig.SharedComponent.loggedInUserInfo["ModeratorGroupId"].length > 0;
    }
    this.getAssociatedGroups();
    this.getAssocoatedFeeds();
    this.getTrendingPostAndTags();
    this.routeSubscription = this.route.queryParams.subscribe((params) => {
      if (!this.helperService.isUndefinedOrNullOrEmpty(params.groupId)) {
        this.selectedGroupId = params.groupId;
      }
      if (!this.helperService.isUndefinedOrNullOrEmpty(params.tag)) {
        this.selectedTag = params.tag;
        this.changeTags(this.selectedTag);
      }
      if (!this.helperService.isUndefinedOrNullOrEmpty(params.feedId)) {
        this.isFeed = true;
        this.selectedfeedId = params.feedId;
      }
    });
  }

  ngDoCheck() {
    if (this.appConfig.SharedComponent.loggedInUserInfo !== null) {
      this.isAdminUser = this.appConfig.SharedComponent.loggedInUserInfo["ModeratorGroupId"].length > 0;
    }
  }

  updateQueryParams() {
    // changes the route without moving from the current view or
    // triggering a navigation event,
    let queryParam = {};
    if (!this.isFeed) {
      queryParam = {
        groupId: this.selectedGroupId,
        tag: this.selectedTag
      };
    } else {
      queryParam = {
        feedId: this.selectedfeedId,
      };
    }
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: queryParam
    });
  }

  ngOnDestroy() {
    // this.routeSubscription.unsubscribe();
  }

  getImgsSanitized(imageURL: any) {
    if (imageURL) {
      return this.sanitizer.bypassSecurityTrustStyle(
        "url(" + imageURL + "), url(/assets/images/user-icon.png)"
      );
    } else {
      return this.sanitizer.bypassSecurityTrustStyle(
        "url(/assets/images/user-icon.png)"
      );
    }
  }

  getTrendingPost() {
    this.communityService
      .getTrendingPots(this.selectedGroupId)
      .subscribe((result) => {
        if (result.Status === ResultStatus.Success) {
          this.trendingPostList = result.Data;
        } else {
          this.toaterService.error("something went wrong");
        }
      });
  }

  getTrendingTags() {
    this.communityService
      .getTrendingTags(this.selectedGroupId)
      .subscribe((result) => {
        if (result.Status === ResultStatus.Success) {
          this.trendingTagList = result.Data;
        } else {
          this.toaterService.error("something went wrong");
        }
      });
  }

  getAssociatedGroups() {
    this.communityService.getAssociatedGroups().subscribe((result) => {
      if (result.Status === ResultStatus.Success) {
        this.groupList = result.Data;
        if (
          !this.helperService.isUndefinedOrNullOrEmpty(this.selectedGroupId) &&
          this.selectedGroupId > 0
        ) {
          const grpValue = this.groupList.filter(
            (x) => x.ID == this.selectedGroupId
          )[0];
          if (grpValue && grpValue.Name) {
            this.addGroupFilter(grpValue.Name);
            if (this.selectedTag) {
              this.addTagFilter();
            }
          }
        }
      } else {
        this.toaterService.error("something went wrong");
      }
    });
  }

  getAssocoatedFeeds() {
    this.communityService.getAssociatedFeeds().subscribe((result) => {
      if (result.Status === ResultStatus.Success) {
        this.feedList = result.Data;
        if (
          !this.helperService.isUndefinedOrNullOrEmpty(this.selectedfeedId) &&
          this.selectedfeedId > 0
        ) {
          const feedValue = this.feedList.filter(
            (x) => x.ID == this.selectedfeedId
          )[0];
          if (feedValue && feedValue.Name) {
            this.addFeedFilter(feedValue.Name);
          }
        }
      } else {
        this.toaterService.error("something went wrong");
      }
    });
  }

  onShowMoreLessClick() {
    this.isShowLess = !this.isShowLess;
    if (this.isShowLess) {
      this.showCounter = this.trendingPostList.length;
    } else {
      this.showCounter = this.showCounterLimit;
    }
  }

  getTrendingPostAndTags() {
    this.getTrendingPost();
    this.getTrendingTags();
  }

  addGroupFilter(groupName) {
    this.filterValue = [];
    this.filterValue.push({
      Text: groupName,
      Area: "Group",
      Value: this.selectedGroupId,
    });
    this.getTrendingPostAndTags();
  }

  changeGroup(id, groupName) {
    this.resetFilters();
    this.communityService.SharedFeedPostComponent.hasValue = false;
    this.selectedGroupId = id;
    this.updateQueryParams();
    this.addGroupFilter(groupName);
  }

  addFeedFilter(feedName) {
    this.filterValue = [];
    this.filterValue.push({
      Text: feedName,
      Area: "Feed",
      Value: this.selectedfeedId,
    });
  }

  changeFeed(id, feedName) {
    this.resetFilters();
    this.communityService.SharedFeedPostComponent.hasValue = false;
    this.isFeed = true;
    this.selectedfeedId = id;
    this.getTrendingPostAndTags();
    this.updateQueryParams();
    this.addFeedFilter(feedName);
  }

  getSavedPost() {
    this.resetFilters();
    this.communityService.SharedFeedPostComponent.hasValue = false;
    this.filterValue = [];
    this.hasSavedPost = true;
  }

  displayCommunityRule() {
    this.openCommunityMenu = false;
    this.bsModalRef = this.modalService.show(
      this.comunityRuleTemplate,
      { backdrop: "static", class: "modal-lg" }
    );
  }

  removeCommunityFilter() {
    this.resetFilters();
    this.updateQueryParams();
  }

  getTrendingPostById(id) {
    let queryParam = {};
    if (!this.isFeed) {
      queryParam = {
        groupId: this.selectedGroupId,
        tag: this.selectedTag
      };
    } else {
      queryParam = {
        feedId: this.selectedfeedId,
      };
    }
    this.router.navigate([
      `/community/post/detail/${id}`,
      {
        queryParams: queryParam
      },
    ]);
  }

  redirectToTrendingPostView() {
    let queryParam = {};
    if (!this.isFeed) {
      queryParam = {
        groupId: this.selectedGroupId,
        tag: this.selectedTag
      };
    } else {
      queryParam = {
        feedId: this.selectedfeedId,
      };
    }
    this.router.navigate([`/trending-post/${this.selectedGroupId}`], {
      queryParams: queryParam
    });
  }

  addTagFilter() {
    this.filterValue = _.remove(this.filterValue, function (item) {
      return item.Area !== "Feed";
    });
    if (this.filterValue.findIndex((item) => item.Area === "Tag") < 0) {
      this.filterValue.push({ Text: this.selectedTag, Area: "Tag" });
    } else {
      this.filterValue[
        this.filterValue.findIndex((item) => item.Area === "Tag")
      ] = { Text: this.selectedTag, Area: "Tag" };
    }
  }

  changeTags(tag) {
    this.openCommunityMenu = false;
    this.communityService.SharedFeedPostComponent.hasValue = false;
    this.isFeed = false;
    this.hasSavedPost = false;
    this.hasReportedPost = false;
    this.selectedTag = tag;
    this.updateQueryParams();
    this.addTagFilter();
  }

  getReportedPost() {
    this.resetFilters();
    this.communityService.SharedFeedPostComponent.hasValue = false;
    this.filterValue = [];
    this.hasReportedPost = true;
  }

  resetFilters() {
    this.openCommunityMenu = false;
    this.hasReportedPost = false;
    this.hasSavedPost = false;
    this.selectedTag = "";
    this.isFeed = false;
    this.selectedfeedId = 0;
    this.selectedGroupId = 0;
  }

  showCommunityMobileMenu() {
    this.openCommunityMenu = !this.openCommunityMenu;
  }

  changeSelectedValue(value) {
    this.communityService.SharedFeedPostComponent.hasValue = false;
    if (!this.helperService.isUndefinedOrNullOrEmpty(value.Tag)) {
      this.changeTags(value.Tag);
    } else {
      this.changeGroup(value.Id, value.Name);
    }
  }

  removeAppliedFilter(filterValue) {
    if (filterValue.Area === "Group") {
      this.selectedGroupId = 0;
      this.filterValue = _.remove(this.filterValue, function (item) {
        return item.Area !== "Group" && item.Value !== filterValue.Value;
      });
    } else if (filterValue.Area === "Feed") {
      this.selectedfeedId = 0;
      this.selectedGroupId = 0;
      this.isFeed = false;
      this.filterValue = _.remove(this.filterValue, function (item) {
        return item.Area !== "Feed" && item.Value !== filterValue.Value;
      });
    } else if (filterValue.Area === "Tag") {
      this.selectedTag = "";
      this.filterValue = _.remove(this.filterValue, function (item) {
        return item.Area !== "Tag";
      });
    }
    this.communityService.SharedFeedPostComponent.hasValue = false;
    this.getTrendingPostAndTags();
    this.updateQueryParams();
  }
}
